import { Component, Input, OnInit } from '@angular/core';
import { FieldConfig } from "@biletix/core/models/base/field-config.model";
import { FormGroup, Validators } from "@angular/forms";

@Component({
    selector: 'btx-phone-input',
    templateUrl: './btx-phone-input.component.html',
    styleUrls: ['./btx-phone-input.component.scss'],
  standalone: false
})
export class BtxPhoneInputComponent implements OnInit {

    @Input() field: FieldConfig | any;
    @Input() group: FormGroup | any;
    @Input() maskPhone: string = "(000) 000 00 00";
    @Input() defaultCountryCode: string = "tr";

    selectedPhonePrefix: string | any = "90";

    constructor() {}

    ngOnInit(): void {
        this.selectedPhonePrefix = this.group.value['phonePrefix'] || "90";
        this.applyValidations();
    }
 
    applyValidations() {
        const control = this.group.get(this.field.name);
        if (control) {
            control.setValidators([
                Validators.required,
                Validators.pattern("^[0-9]*$"),  
                Validators.minLength(7),        
                Validators.maxLength(12)       
            ]);
            control.updateValueAndValidity();
        }
    }

    setPhonePrefix(phonePrefix: string) {
        this.selectedPhonePrefix = phonePrefix;
        
        this.group.patchValue({
            "phonePrefix": phonePrefix,
        }); 
        if (phonePrefix !== '90') {
            this.maskPhone = ""; 
        } else {
            this.maskPhone = "(000) 000 00 00";
        }
        
        this.applyValidations();
    }
}